import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

/**
 * Корень держит только контекст: оболочка админки живёт в layout-маршруте `_app`, а экраны
 * входа и смены пароля рисуются без неё — меню и разделы до входа всё равно недоступны.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
});
